export default {
    Comm:{
        back:"返回",
        fbsj:'发布时间'
    },
    Nav: {
        sy:'首页',
        gywm:'关于我们',
        gywm_gsjj:"公司简介",
        gywm_gsry:"公司荣誉",
        gywm_gssq:"公司视频",
        gywm_gswz:"地理位置",
        gywm_qywh:"企业文化",
        gywm_shzr:"社会责任",
        cpyfw:'产品与服务',
        cpyfw_cpml:'产品目录',
        cpyfw_gylx:'工艺路线',
        cpyfw_jscb:'技术储备',
        cpyfw_zzrz:'资质认证',
        cpyfw_zlhzhb:'战略合作伙伴',
        cpyfw_yxwl:'营销网络',
        jsyf:'技术研发',
        jsyf_yfdw:'研发队伍',
        jsyf_yqhz:'院企合作',
        jsyf_yfcg:'研发成果',
        jsyf_zlbz:'专利标准',
        xwzx:'新闻资讯',
        lshb:'绿色环保',
        djyd:'党群园地',
        djyd_xxyw:'学习要闻',
        djyd_jbgk:'基本概况',
        djyd_dqdt:'党群动态',
        djyd_ghzc:'工会之窗',
        zpzx:'招聘中心',
        lxwm:'联系我们',
        wxgxh:'微信扫一扫关注我们',
        wx_jljt:'建龙集团',
        wx_cdjl:'承德建龙'
    },
    home:{
        pName:'中科国安河北信息技术有限公司',
        dizhi:'地址：河北省石家庄市高新区长江道壹号A座2010',
        youbian:'邮编：050035',
        xsdh:'咨询热线：0311-88801394',
        xzdh:'',
        bqsy:'版权所有：中科国安河北信息技术有限公司',
        jszc:'Zhongkeguoan Hebei Information Technology Co., Ltd.',
        home11:'绿色环保系列',
        home12:'承德建龙遵循“珍爱生命、珍视环境”的安全环保理念，走可持续发展道路。以“污染物超低排放、绿色低碳”为重点，利用先进的治理技术，通过数字化、智能化、精细化管控手段，实现污染物排放最小化、无害化、资源化，最终实现科技先导、低碳环保的绿色企业。',
        home21:'用心做好产品',
        home22:'近三年获中国钢铁工业协会冶金科学技术奖3项、北京市科技进步奖1项、河北省冶金科学技术奖6项。其中《超低氧易切削变速箱齿轮钢多工序协同控制技术及应用》项目整体成果达到国际先进水平，并荣获中国钢铁协会冶金科学技术二等奖；《高品质连铸大圆坯生产关键技术及高端产品研发》项目成果达到国际先进水平，部分关键指标达到国际领先水平，并荣获中国钢铁协会冶金科学技术三等奖。',
        home31:'技术先进',
        home32:'公司长期聚焦于科技引领、创新驱动，与北京科技大学、东北大学、上海大学、中南大学等知名院校建立长期合作关系，并开展了多项合作研发项目，每年支付合作经费约600万元。2021年5月26日，邀请中南大学邱冠周院士，合作组建了承德建龙特殊钢有限公司院士工作站。',
        home41:'勇于担当，回馈社会',
        home42:'承德建龙秉着“珍爱生命，珍视环境”的安环理念，在基础设施建设及环境保护方面做出巨大贡献。一是产城融合方面。2017 年以来，累计投资 5400 万元建设了 1#、2# 两座高炉冲渣水换热站，为平安新区、平安矿业等 3300 多户周边村民解决了冬季供暖问题，供暖面积近 70 万平方米，为减少碳排放贡献了力量',
        homeMore:'点击了解详情'

    },
    product:{
        mulu01:'圆坯',
        mulu02:'钢管',
        mulu03:'圆管',
        mulu04:'钒产品'},
    recruit:{
        zp1:'校园招聘',
        zp2:'社会招聘',
        zp3:'公开竞聘',
        tip1:"所属部门",
        tip2:"岗位名称",
        tip3:"学历要求",
        tip4:"专业要求",
        tip5:"操作",
        tip6:"查看详情"
    }
};
